import * as actionTypes from '../constants/actionTypes';
export function showHandoff(initialZoomPosition) {
    return {
        type: actionTypes.SHOW_HANDOFF,
        initialZoomPosition: initialZoomPosition,
    };
}
export function hideHandoff() {
    return {
        type: actionTypes.HIDE_HANDOFF,
    };
}
export function changeHandoffSelectedItem(index) {
    return {
        type: actionTypes.CHANGE_HANDOFF_SELECTED_ITEM,
        index: index,
    };
}
export function changeHandoffSelectedItemByUUID(uuid) {
    return {
        type: actionTypes.CHANGE_HANDOFF_SELECTED_ITEM_BY_UUID,
        uuid: uuid,
    };
}
export function incrementZoom() {
    return {
        type: actionTypes.INCREMENT_ZOOM,
    };
}
export function decrementZoom() {
    return {
        type: actionTypes.DECREMENT_ZOOM,
    };
}
export function fitZoom() {
    return {
        type: actionTypes.FIT_ZOOM,
    };
}
export function setInitialHandoffZoomFlag() {
    return {
        type: actionTypes.SET_INITIAL_HANDOFF_ZOOM_FLAG,
    };
}
export function deselectHandoffItem(index) {
    return {
        type: actionTypes.DESELECT_HANDOFF_ITEM,
        index: index,
    };
}
export function changeHandoffHoveredItem(index) {
    return {
        type: actionTypes.CHANGE_HANDOFF_HOVERED_ITEM,
        index: index,
    };
}
export function changeHandoffHoveredItemByUUID(uuid) {
    return {
        type: actionTypes.CHANGE_HANDOFF_HOVERED_ITEM_BY_UUID,
        uuid: uuid,
    };
}
export function setCanvas(canvas, sourcePlatform) {
    return {
        type: actionTypes.SET_CANVAS,
        canvas: canvas,
        sourcePlatform: sourcePlatform,
    };
}
export function loadCanvasStarting() {
    return {
        type: actionTypes.LOAD_CANVAS_STARTING,
    };
}
export function loadCanvasDone(canvas, sourcePlatform) {
    return {
        type: actionTypes.LOAD_CANVAS_DONE,
        canvas: canvas,
        sourcePlatform: sourcePlatform,
    };
}
export function loadCanvasFailed() {
    return {
        type: actionTypes.LOAD_CANVAS_FAILED,
    };
}
export function toggleColumnOverlay() {
    return {
        type: actionTypes.TOGGLE_COLUMN_OVERLAY,
    };
}
export function toggleRowOverlay() {
    return {
        type: actionTypes.TOGGLE_ROW_OVERLAY,
    };
}
export function setUnit(unit) {
    return {
        type: actionTypes.SET_UNIT,
        unit: unit,
    };
}
export function setColorMode(colorMode) {
    return {
        type: actionTypes.SET_COLOR_MODE,
        colorMode: colorMode,
    };
}
export function updateZoomPosition(zoomPosition) {
    return {
        type: actionTypes.UPDATE_ZOOM_POSITION,
        zoomPosition: zoomPosition,
    };
}
export function enablePercentageBasedGuidelines() {
    return setPercentageBasedGuidelines(true);
}
export function disablePercentageBasedGuidelines() {
    return setPercentageBasedGuidelines(false);
}
function setPercentageBasedGuidelines(value) {
    return {
        type: actionTypes.SET_PERCENTAGE_BASED_GUIDELINES,
        value: value,
    };
}
